import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/app/buy-the-book-contact/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/app/buy-the-book-contact/components/NewsletterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/app/buy-the-book-contact/components/PurchaseSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960ee637683ed00148142db/mafa_press/src/components/ui/AppIcon.tsx");
